module.exports = __webpack_public_path__ + "img/Motor_saf_2.ef41316f.jpg";